export interface IApiConfig {
  apiKeys: any[]
  apiUrl: string
  servicebusConnectionString: string
}

let cachedConfig: IApiConfig | null = null

export const useConfig = async (): Promise<IApiConfig> => {
  const apiConfig: IApiConfig = { apiKeys: [], servicebusConnectionString: '', apiUrl: '' }
  // Check if running on the client side
  if (import.meta.client) {
    return apiConfig
  }
  if (cachedConfig) return cachedConfig
  const configApiUrl = process.env.CONFIG_API_URL ?? 'http://localhost'
  const configApiKey = process.env.CONFIG_API_KEY ?? 'API_KEY_1'

  // We can 't use NODE_ENV as Nuxt overwrites it
  const env = (process.env.NAMESPACE == 'dev' || process.env.NAMESPACE == undefined ? 'development' : 'production')
  console.log(env)
  const url = configApiUrl + '/config/v1/config/' + env + '?settings=api_keys,skyvisitor,servicebus_connection_string,api_url'
  const result = await fetch(url, { headers: { 'x-api-key': configApiKey } })
  if (result.status != 200) throw new Error('Fetching config failed')
  const json = await result.json()
  apiConfig.apiKeys = json.api_keys
  apiConfig.apiUrl = json.api_url
  apiConfig.servicebusConnectionString = json.servicebus_connection_string
  cachedConfig = apiConfig
  return apiConfig
}
